<script>
  import { t } from "../i18n/i18n"
  import { tenantStore, userStore, snackBarStore } from "../state/store"
  import Button from "./Button.svelte"
  import PlanInfo from "./PlanInfo.svelte"
  import { request } from '../helpers/api'
  import {
    PRICE_ID_DEVELOPMENT_PRO,
    PRICE_ID_DEVELOPMENT_BASIC,
    PRICE_ID_PROD_BASIC,
    PRICE_ID_PROD_PRO
  } from "../helpers/constants"

  const jwtDecode = require('jwt-decode')

  let selectedPlan = ''
  let pending = false
  let priceId

  const selectPlan = (plan) => {
    // TODO: update plan metadata in stripe to add tiers.
    selectedPlan = plan
    if (process.env.NODE_ENV === 'development' && plan === 'basic') {
      priceId = PRICE_ID_DEVELOPMENT_BASIC
    }
    if (process.env.NODE_ENV === 'development' && plan === 'pro') {
      priceId = PRICE_ID_DEVELOPMENT_PRO
    }
    if (process.env.NODE_ENV === 'production' && plan === 'basic') {
      priceId = PRICE_ID_PROD_BASIC
    }
    if (process.env.NODE_ENV === 'production' && plan === 'pro') {
      priceId = PRICE_ID_PROD_PRO
    }
  }

  const updateSubscription = async () => {
    try {
      pending = true
      const token = await request({
        url: '/api/subscriptions',
        method: 'PUT',
        body: JSON.stringify({
          priceId,
          customerId: $userStore.tenant_id,
          plan: selectedPlan
        })
      })
      sessionStorage.setItem('token', token)
      const { user } = jwtDecode(token)
      userStore.set(user)
      selectedPlan = ''
      snackBarStore.set({ message: $t['settings_updated'], type: 'success', selfDestruct: true})
    } catch (error) {
      if (error.message === 'too many users') {
        snackBarStore.set({ message: $t.too_many_users, type: 'error', selfDestruct: true })
        return
      }
      snackBarStore.set({ message: $t.something_wrong, type: 'error', selfDestruct: true })
    }
    pending = false
  }

  const createSubscription = async () => {
    try {      
      pending = true
      const token = await request({
          url: '/api/subscriptions',
          method: 'PATCH',
          body: JSON.stringify({
            customerId: $tenantStore._id,
            priceId
          }),
        })
      snackBarStore.set({ message: $t.settings_updated, type: 'success' })
      sessionStorage.setItem('token', token)
      const { user } = jwtDecode(token)
      userStore.set(user)
    } catch (error) {
      snackBarStore.set({ message: $t.no_payment_plan_error, type: 'error' })
    }
    pending = false
  }

</script>

<style>
  section {
    display: grid;
    gap: 4rem;
    grid-template-columns: repeat(auto-fit, minmax(45rem, 1fr));
    margin: 2rem 0;
  }
  .card {
    padding: 2rem;
    border-radius: var(--radius);
    max-width: 55rem;
    border: 1px solid transparent;
  }
  footer {
    display: flex;
    justify-content: flex-end;
  }
  .active {
    border: 1px solid var(--light-blue);
  }

  p {
    text-align: center;
  }
</style>

<article>
  <h3>Change plan</h3>
  <section>
    <div class="card" class:active={selectedPlan === 'basic'}>
      <PlanInfo plan="basic" />
      <Button on:click={() => selectPlan('basic')} disabled={($userStore.status !== 'no_active_subscriptions' && $userStore.tier === 'basic') || pending }>{$userStore.status !== 'no_active_subscriptions' && $userStore.tier === 'basic' ? $t.current_plan : $t.select_this_plan}</Button>
    </div>
    <div class="card" class:active={selectedPlan === 'pro'}>
      <PlanInfo plan="pro" />
      <Button on:click={() => selectPlan('pro')} disabled={($userStore.status !== 'no_active_subscriptions' && $userStore.tier === 'pro') || pending }>{$userStore.status !== 'no_active_subscriptions' && $userStore.tier === 'pro' ? $t.current_plan : $t.select_this_plan}</Button>
    </div>
  </section>
  <footer>
    {#if selectedPlan && $userStore.status === 'no_active_subscriptions'}
      <Button on:click={() => createSubscription()} >{$t.change_plan_button($t[selectedPlan])}</Button>
    {:else if selectedPlan}
      <Button on:click={() => updateSubscription()} >{$t.change_plan_button($t[selectedPlan])}</Button>
    {/if}
  </footer>
  {#if $userStore.status === 'trialing'}
    <p>{Math.floor(($userStore.trial_end - Math.floor(Date.now() / 1000)) / 86400)} day(s) left in your trial</p>
  {/if}
</article>
